const reportWebVitals = (onPerfEntry?: any) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((mod: any) => {
      mod.getCLS?.(onPerfEntry);
      mod.getFID?.(onPerfEntry);
      mod.getFCP?.(onPerfEntry);
      mod.getLCP?.(onPerfEntry);
      mod.getTTFB?.(onPerfEntry);
    });
  }
};

export default reportWebVitals;
